(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const isMobile = $(window).width() < 768;
    
    /* cs-image */
    $('.cs-image').each(function (index) {
      let json = $(this).attr('data-json');
      if(!json) return;
      let data = JSON.parse(json);
      if(!isMobile){
        $(this).addClass(data.mode);
        $(this).attr('src', data.src);
        $(this).attr('alt', data.alt);
      }else{
        $(this).addClass(data.mode_mb);
        $(this).attr('src', data.src_mb);
        $(this).attr('alt', data.alt_mb);
      }
    })
    /* cs-image */
  })
})()